export interface ConnectedPayload {
  ok: boolean;
  user_id: string;
}

export enum Channel {
  TASK = "TASK",
  NOTIFICATION = "NOTIFICATION",
  WHATSAPP = "WHATSAPP",
  ANALYSIS_NOTE = "ANALYSIS_NOTE",
}


